import React from 'react'

function FacebookLogo() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M20.7397 10.2141C20.7397 4.69124 16.2626 0.214096 10.7397 0.214096C5.21689 0.214096 0.739746 4.69124 0.739746 10.2141C0.739746 15.2055 4.39653 19.3427 9.17725 20.0927V13.1048H6.63832V10.2141H9.17725V8.01088C9.17725 5.50481 10.6701 4.12052 12.9544 4.12052C14.0487 4.12052 15.193 4.31553 15.193 4.31553V6.7766H13.9319C12.6897 6.7766 12.3022 7.54731 12.3022 8.33838V10.2141H15.0758L14.6322 13.1048H12.3022V20.0927C17.083 19.3427 20.7397 15.2055 20.7397 10.2141Z" fill="#1877F2"/>
  </svg>
}

export default FacebookLogo
